import React from 'react';
import { Flex, Box } from 'rebass/styled-components';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Header: React.FC<{
  mb?: string | number | undefined,
  dark?: boolean,
  childContainerStyle?: React.CSSProperties,
  containerStyle?: React.CSSProperties,
}> = ({mb =4, dark=false, children, childContainerStyle={}, containerStyle={}}) => (
  <Flex
    width={1}
    flex={1}
    mt={5}
    mb={mb || 4}
    justifyContent="center"
    flexDirection="column"
    alignItems="center"
    style={containerStyle}
  >
    <Box width={[1 / 2, 1 / 3, 1 / 4]}>
      <Link to="/">
        <Logo
          dark={
            dark === null || dark === undefined ? true : dark
          }
        />
      </Link>
    </Box>
    <Flex mb={3} justifyContent="center" style={childContainerStyle}>
      {children}
    </Flex>
  </Flex>
);

export default Header;
